import { useMemo } from 'react'

// eslint-disable-next-line import/no-internal-modules
import { selectPrimaryIntegration } from '@webapp/utils/integration/selectPrimaryIntegration'
import { useQueryIntegrationsList } from '../../models/useQueryIntegrationsList'

export const useGetIntegrationsListPresenter = ({
  enabled = true,
}: {
  enabled?: boolean
} = {}) => {
  const { integrations, isLoading, isError } = useQueryIntegrationsList({
    enabled,
  })

  const activeIntegrations = useMemo(
    () => integrations.filter((integration) => integration.isActive),
    [integrations]
  )

  const primaryIntegration = selectPrimaryIntegration(activeIntegrations)

  return {
    data: {
      integrations,
      activeIntegrations,
      primaryIntegration,
    },
    states: {
      isLoading,
      isError,
    },
  }
}
